import "../../assets/css/mail-info.css";
import { useState } from 'react';
import { Modal } from 'slide-ui';
import Panel from "../Panel/Panel";
import SendMailInfo from './SendMailInfo';
import LearnMoreButton from "../ProfileButtons/LearnMoreButton";
import { wrapAuthData } from "../AuthData/AuthData";
const shimmerProps = {height: "240px"};
const requires = ["commitment", "child", "communityNews"];

const SendMail = function(props) {
  const [showModal, setShowModal] = useState(false);
  const { requiredData } = props;

  return (
    <Panel classList="panel__send-mail">
      <h3 className="eta">Send mail</h3>
      <p>You can also send letters, cards, or small packages to your sponsored child. Learn how, and get your sponsored child's mailing address.</p>
      
      <div>
        <LearnMoreButton handleClick={() => setShowModal(!showModal)}>Learn More</LearnMoreButton>

        <Modal 
          toggle={() => setShowModal(false)}
          isOpen={showModal}
          hasTitle={false}
          hasFooter={false}
          classList="send-mail-modal"
          sendClick={() => {}}
        >
          <SendMailInfo
            data={requiredData}
          />
        </Modal>  
      </div>
    </Panel>
  );
 }
 
 export default wrapAuthData(SendMail, {shimmerProps, requires, name: "SendMail"});